import React, { HTMLAttributes, useContext } from 'react'

import { useI18n } from '@shopify/react-i18n'
import { Radio, Row, Text } from '@vividseats/vivid-ui-kit'

import relatedProductionsContext from '@/context/related-productions'
import { getFormattedCurrency } from '@/utils/i18n'

import styles from './styles.module.scss'

interface Props extends HTMLAttributes<HTMLLabelElement> {
    checked: boolean
    date: string
    minPrice: number
    ticketCount: number
}

const RelatedProductionOption: React.FC<Props> = ({ checked, date, minPrice, ticketCount, ...htmlAttributes }) => {
    const [i18n] = useI18n()
    const {
        selectors: { i18nRelatedProductionsDataSelector },
    } = useContext(relatedProductionsContext)

    const { applyCurrencyConversion, to } = { ...i18nRelatedProductionsDataSelector }

    const label = (
        <Row className={styles.label} justify="top">
            <Text className={styles.title} size="md" weight="semi-bold">
                {date}
            </Text>
            <Text size="md" state="muted">
                <span className={styles.ticketCount}>{ticketCount} tickets</span>
                {String.fromCharCode(8226)}
                <span className={styles.minPrice} data-testid="related-minPrice">
                    from {getFormattedCurrency(i18n, minPrice, to, applyCurrencyConversion, 0)}
                </span>
            </Text>
        </Row>
    )

    return <Radio checked={checked} className={styles.radio} label={label} {...htmlAttributes} />
}

export default RelatedProductionOption
